'use client';

import { useDecisions } from './useDecisions';

export const useAutoshipDecisions = () => {
    const autoshipType = useDecisions('ff_autoship');

    return {
        isAutoshipCrawl: autoshipType === 'crawl',
        isAutoshipPreCrawl: autoshipType === 'precrawl',
    };
};
